import { Capacitor } from '@capacitor/core';
import { getApp } from 'firebase/app';
import { Auth, initializeAuth, indexedDBLocalPersistence, getAuth } from 'firebase/auth';
import { UnreadMessagesMap } from 'firebase/types/redux/firebaseState';
import { isEmpty, isObject } from 'lodash';

export function getFirebaseAuth(): Auth {
    let auth;
    if (Capacitor.isNativePlatform()) {
        const app = getApp();
        auth = initializeAuth(app, {
            persistence: indexedDBLocalPersistence,
        });
    } else {
        auth = getAuth();
    }
    return auth;
}

export const countUnreadMessages = (
    data: unknown,
    activeChannelIds: string[],
    selectedChannelId?: string | null,
): number => {
    if (!data || !isObject(data) || isEmpty(data)) {
        return 0;
    }

    const unreadMap = data as UnreadMessagesMap;
    const unread = Object.entries(unreadMap).reduce((acc, [channelId, count]) => {
        // Only count unread messages for active channels,
        // some service request channels may be archived
        if (activeChannelIds.includes(channelId)) {
            // Also skip unread messages for currently selected chat
            if (channelId === selectedChannelId) {
                return acc;
            }

            return acc + count;
        }

        return acc;
    }, 0);

    return unread;
};
